<template>
        <div class="mainpage">
            <div class="whitebox test">
                <h1>Test Results</h1>
                <h3>Results Summary (taken on {{time | date}})</h3>
                <div class="testbox">
                    <ul class="results_list">
                        <li v-for="(i, index) in list" :key="index"><label>{{i.value}}%</label>
                            <div><b :style="{width: i.value+'%', 'background-color': colors[index]}"></b></div>
                            <span>{{i.key}}</span></li>
                    </ul>

                </div><!--testbox end--->

                <div class="adbanner">
                    <!--<a href="https://www.kinkdapp.com/app.html" target="_blank">
                    <img src="/images/banner.png" width="540" height="300" alt=""/></a> -->
                    <a href="https://www.kinkdapp.com/download.html" target="_blank">
                    <img src="/images/banner-month.png" width="540" height="300" alt=""/></a>
                </div>

                <div class="testbox">
                    <div class="copybox">
                        <div class="c_left">
                            <p v-for="(i, index) in list" :key="index"><b style="padding-right: 0px">{{i.value}}%&nbsp;&nbsp;</b><span>{{i.key}}&nbsp;</span></p>
                        </div>
                        <div class="c_right">
                            <button @click="copyResult">Copy Text</button>
                            <button @click="copyLink">Copy Link</button>
                        </div>
                    </div><!---copybox end--->
                </div><!---testbox end--->
                <div class="testbox share">
                    <label>Share on:</label>
                    <div>
                        <i class="icon_fb" @click="share('facebook','Kink Test')"></i>
                        <i class="icon_twitter" @click="share('twitter','Kink Test')"></i>
                        <i class="icon_tublr" @click="share('tumblr','Kink Test')"></i>
                        <!--<amp-social-share style="background-color: white" type="instagram"><i class="icon_ins" :data-param-app_id="id"></i></amp-social-share>-->
                    </div>
                </div><!---testbox end--->

            </div><!--whitebox end--->
        </div><!--mainpage end--->
</template>
<script>
    import util from '../util';
    import config from '../config';
    import timestamp from 'time-stamp';
    import gradient from 'gradient-color';
    import * as clipboard from "clipboard-polyfill"
    import { Message } from 'element-ui'

    export default {
        name:"test_result",
        props:{
            id:{}
        },
        data(){
            return {
                time:null,
                age:null,
                email:null,
                list:[],
                colors:[],
            }
        },
        filters:{
            date(time){
                return timestamp('MM/DD/YYYY HH:mm',new Date(time));
            }
        },
        methods:{
            share(type,title,w=600,h=400) {
                let wLeft = window.screenLeft ? window.screenLeft : window.screenX;
                let wTop = window.screenTop ? window.screenTop : window.screenY;
                let left = wLeft + (window.innerWidth / 2) - (w / 2);
                let top = wTop + (window.innerHeight / 2) - (h / 2);
                let url='',shareUr=document.URL;
                switch (type) {
                    case 'facebook':url=`https://www.facebook.com/sharer/sharer.php?u=${shareUr}`
                        break;
                    case 'twitter':url=`https://twitter.com/share?u=${shareUr}`
                        break;
                    case 'tumblr':url=`https://www.tumblr.com/widgets/share/tool?canonicalUrl=${shareUr}`
                }
                window.open(url, title, `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`);
            },
            copyResult(){
                let dt = new clipboard.DT()
                let copyDom = this.$el.querySelector(".copybox .c_left")
                dt.setData("text/plain", copyDom.innerText);
                dt.setData("text/html", new XMLSerializer().serializeToString(copyDom));
                clipboard.write(dt);
                // clipboard.copy(.innerText);
                Message({
                    message: 'Copied Successfully!',
                    duration:1500,
                    center: true
                });
            },
            copyLink(){
                clipboard.writeText(document.URL);
                Message({
                    message: 'Copied Successfully!',
                    duration:1500,
                    center: true
                });
            },
            getData(){
                if(this.id){
                    util.axios.post(config.test_result_url,{
                        id:this.id
                    }).then((data)=>{
                        if(data){
                            this.time = data.datetime;
                            this.age = data.age;
                            this.email = data.email;
                            this.setList(data.testResult);
                            this.getColors();
                        }
                    })
                }
            },
            setList(data){
                let array = [];
                for(let i in data){
                    array.push({
                        key:i,
                        value:data[i]
                    });
                }
                array.sort((a,b)=>{
                    return b.value / 1 - a.value / 1;
                })
                this.list = array;
            },
            getColors(){
                this.colors = gradient(config.test_result_colors,this.list.length);
            },
        },
        mounted(){
            this.getData();
        }
    }
</script>

<style scoped>

</style>
